import type { ClaimResponse } from './claim-response';

export const claimResponseRejected: ClaimResponse = {
  MedicalAidMessage: {
    '@Version': '6.0.0',
    Claim: {
      Transaction: {
        ReferenceNum: '220818194119697o21aijl',
        DataSet: '01',
        InvoiceNum: 'QM202208-00006',
      },
      Details: {
        ClaimFinancials: {
          TotalClaimedAmt: '58396',
          TotalPaidProvAmt: '0',
          BalanceOutstanding: '58396',
        },
        LineItems: [
          {
            UniqueID: '0',
            StatusCode: '8',
            StatusDesc: 'Rejected',
            Editable: 'Yes',
            Reversible: 'No',
            PayWho: 'Provider',
            LineItemFinancials: {
              BilledAmt: '480',
              MAPayable: '0',
            },
            Responses: [
              {
                '@Type': 'Error',
                Code: '757',
                Desc: '1. 757 Invalid treating provider..',
              },
            ],
          },
          {
            UniqueID: '1',
            StatusCode: '8',
            StatusDesc: 'Rejected',
            Editable: 'Yes',
            Reversible: 'No',
            PayWho: 'Provider',
            LineItemFinancials: {
              BilledAmt: '43410',
              MAPayable: '0',
            },
            Responses: [
              {
                '@Type': 'Error',
                Code: '757',
                Desc: '1. 757 Invalid treating provider..',
              },
            ],
          },
          {
            UniqueID: '2',
            StatusCode: '8',
            StatusDesc: 'Rejected',
            Editable: 'Yes',
            Reversible: 'No',
            PayWho: 'Provider',
            LineItemFinancials: {
              BilledAmt: '4697',
              MAPayable: '0',
            },
            Responses: [
              {
                '@Type': 'Error',
                Code: '757',
                Desc: '1. 757 Invalid treating provider..',
              },
            ],
          },
          {
            UniqueID: '3',
            StatusCode: '8',
            StatusDesc: 'Rejected',
            Editable: 'Yes',
            Reversible: 'No',
            PayWho: 'Provider',
            LineItemFinancials: {
              BilledAmt: '9809',
              MAPayable: '0',
            },
            Responses: [
              {
                '@Type': 'Error',
                Code: '757',
                Desc: '1. 757 Invalid treating provider..',
              },
            ],
          },
        ],
        Responses: [
          {
            '@Type': 'Error',
            Code: '9808',
            Desc: 'Invalid billing provider,Content Failure.,',
          },
        ],
      },
    },
  },
};
